import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n.use(Backend).use(LanguageDetector).use(initReactI18next);

export const init = () => {
  return i18n.init({
    fallbackLng: 'en-US',
    debug: process.env.NODE_ENV !== 'production',
    backend: {
      // Prefix with PUBLIC_URL so locales load correctly when the app is
      // hosted under a sub-path (e.g. GitHub Pages project pages).
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });
};

export default i18n;
